// extracted by mini-css-extract-plugin
module.exports = {"section":"footer_section__2QlJg","block1":"footer_block1__v4_pS","block2":"footer_block2__KCu3v","block3":"footer_block3__qYGdK","block4":"footer_block4__3yA1a"};